var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setPassPage"},[_c('Back'),_c('Login',{attrs:{"loginType":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }